import axios from "axios";

export const ForbiddenKeywordTranport = {
    list: async (): Promise<any[]> => {
        const { data } = await axios.get("/forbiddenKeywords", {});
        return data;
    },
    save: async (keywords: string): Promise<void> => {
        await axios.request({
            method: "post",
            url: "/forbiddenKeywords",
            data: { keywords },
        });
    },
};
